import { z } from 'zod';

export const InstagramUrlSchema = z
  .string()
  .trim()
  .regex(/^https?:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._-]+\/?$/, {
    message: 'VALIDATION__InvalidInstagramUrl',
  });

export const FacebookUrlSchema = z
  .string()
  .trim()
  .regex(/^https?:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?$/, {
    message: 'VALIDATION__InvalidFacebookUrl',
  });

export const TwitterUrlSchema = z
  .string()
  .trim()
  .regex(/^https?:\/\/(www\.)?(twitter|x)\.com\/[a-zA-Z0-9_]+\/?$/, {
    message: 'VALIDATION__InvalidTwitterUrl',
  });
export const LinkedInUrlSchema = z
  .string()
  .url({ message: 'VALIDATION__InvalidLinkedInUrl' })
  .refine(
    (value) => {
      try {
        const url = new URL(value);
        return (
          url.hostname === 'linkedin.com' || url.hostname === 'www.linkedin.com'
        );
      } catch {
        return false;
      }
    },
    {
      message: 'VALIDATION__InvalidLinkedInUrl',
    },
  );

export const TikTokUrlSchema = z
  .string()
  .url({ message: 'VALIDATION__InvalidTikTokUrl' })
  .refine(
    (value) => {
      try {
        const url = new URL(value);
        return (
          url.hostname === 'tiktok.com' || url.hostname === 'www.tiktok.com'
        );
      } catch {
        return false;
      }
    },
    {
      message: 'VALIDATION__InvalidTikTokUrl',
    },
  );
